import Vue from 'vue';
import { MutationTree } from 'vuex';
import { SurgicalPerson, SurgicalPersonsState } from '@/store/surgicalPersons/types';

export const mutations: MutationTree<SurgicalPersonsState> = {
  setSurgicalPeople(state, any) {
    Vue.set(state, 'surgicalPeopleFiltered', any);
  },
};
